import { render, staticRenderFns } from "./SGBackups.vue?vue&type=template&id=504f1811&scoped=true"
import script from "./SGBackups.vue?vue&type=script&lang=js"
export * from "./SGBackups.vue?vue&type=script&lang=js"
import style0 from "./SGBackups.vue?vue&type=style&index=0&id=504f1811&prod&scoped=true&lang=css"
import style1 from "./SGBackups.vue?vue&type=style&index=1&id=504f1811&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504f1811",
  null
  
)

export default component.exports